/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NftsForAddress_User = {
    readonly id: string;
    readonly " $refType": "NftsForAddress_User";
};
export type NftsForAddress_User$data = NftsForAddress_User;
export type NftsForAddress_User$key = {
    readonly " $data"?: NftsForAddress_User$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"NftsForAddress_User">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftsForAddress_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'c6b42bc1b7567f49120771645c9063b3';
export default node;
